import { Autorenew, Delete, SettingsPower, type SvgIconComponent } from '@mui/icons-material';
import { DeviceCommandKind } from '~/generated/graphql';
import { i18n } from '~/lib/i18n';

export interface Command {
  Icon: SvgIconComponent;
  command: DeviceCommandKind;
  description: string;
  payload?: object;
  title: string;
}

export const initialCommands: Command[] = [
  {
    Icon: Delete,
    command: DeviceCommandKind.Purge,
    description: i18n.t('pages.devices.show.commands.delete_content_description'),
    title: i18n.t('pages.devices.show.commands.delete_content'),
  },
  {
    Icon: SettingsPower,
    command: DeviceCommandKind.Reboot,
    description: i18n.t('pages.devices.show.commands.reboot_description'),
    title: i18n.t('pages.devices.show.commands.reboot'),
  },
  {
    Icon: Autorenew,
    command: DeviceCommandKind.Restart,
    description: i18n.t('pages.devices.show.commands.restart_description'),
    title: i18n.t('pages.devices.show.commands.restart'),
  },
];
